// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1NLKz","title":"AfterFrontImage_title__21VhJ"};